<template>
    <div id="Statistical_Into">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>订单统计</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row :gutter="20" class="display">
            <el-col :span="6">
                <div class="order-head" style="background: #2c8fed">
                    <div class="head-top">
                        <h5>今日充值</h5>
                        <p>¥{{today.charge_total}}</p>
                    </div>
                    <div class="head-bottom">
                        <div class="head-bottom-item">
                            <h5>普通充值</h5>
                            <span>{{today.charge}}</span>
                            <p>已支付: <span>{{today.charge_pays}}</span> 笔</p>
                            <p>未支付: <span>{{today.charge_unpays}}</span> 笔</p>
                            <p>完成率: <span>{{today.complete_rate}}%</span></p>
                        </div>
                        <div class="head-bottom-item">
                            <h5>VIP会员</h5>
                            <span>{{today.vip}}</span>
                            <p>已支付: <span>{{today.vip_pays}}</span> 笔</p>
                            <p>未支付: <span>{{today.vip_unpays}}</span> 笔</p>
                            <p>完成率: <span>{{today.vip_complete_rate}}%</span></p>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="order-head" style="background: #2BCF43">
                    <div class="head-top">
                        <h5>昨日充值</h5>
                        <p>¥{{yesterday.charge_total}}</p>
                    </div>
                    <div class="head-bottom">
                        <div class="head-bottom-item">
                            <h5>普通充值</h5>
                            <span>{{yesterday.charge}}</span>
                            <p>已支付: <span>{{yesterday.charge_pays}}</span> 笔</p>
                            <p>未支付: <span>{{yesterday.charge_unpays}}</span> 笔</p>
                            <p>完成率: <span>{{yesterday.complete_rate}}%</span></p>
                        </div>
                        <div class="head-bottom-item">
                            <h5>VIP会员</h5>
                            <span>{{yesterday.vip}}</span>
                            <p>已支付: <span>{{yesterday.vip_pays}}</span> 笔</p>
                            <p>未支付: <span>{{yesterday.vip_unpays}}</span> 笔</p>
                            <p>完成率: <span>{{yesterday.vip_complete_rate}}%</span></p>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="order-head" style="background: #F5CB4E">
                    <div class="head-top">
                        <h5>本月充值</h5>
                        <p>¥{{month.charge_total}}</p>
                    </div>
                    <div class="head-bottom">
                        <div class="head-bottom-item">
                            <h5>普通充值</h5>
                            <span>{{month.charge}}</span>
                            <p>已支付: <span>{{month.charge_pays}}</span> 笔</p>
                            <p>未支付: <span>{{month.charge_unpays}}</span> 笔</p>
                            <p>完成率: <span>{{month.complete_rate}}%</span></p>
                        </div>
                        <div class="head-bottom-item">
                            <h5>VIP会员</h5>
                            <span>{{month.vip}}</span>
                            <p>已支付: <span>{{month.vip_pays}}</span> 笔</p>
                            <p>未支付: <span>{{month.vip_unpays}}</span> 笔</p>
                            <p>完成率: <span>{{month.vip_complete_rate}}%</span></p>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="order-head" style="background: #FA5A4C">
                    <div class="head-top">
                        <h5>累计充值 (含当日)</h5>
                        <p>¥{{total.charge_total}}</p>
                    </div>
                    <div class="head-bottom">
                        <div class="head-bottom-item">
                            <h5>普通充值</h5>
                            <span>{{total.charge}}</span>
                            <p>已支付: <span>{{total.charge_pays}}</span> 笔</p>
                            <p>未支付: <span>{{total.charge_unpays}}</span> 笔</p>
                            <p>完成率: <span>{{total.complete_rate}}%</span></p>
                        </div>
                        <div class="head-bottom-item">
                            <h5>VIP会员</h5>
                            <span>{{total.vip}}</span>
                            <p>已支付: <span>{{total.vip_pays}}</span> 笔</p>
                            <p>未支付: <span>{{total.vip_unpays}}</span> 笔</p>
                            <p>完成率: <span>{{total.vip_complete_rate}}%</span></p>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-card class="box-card">
            <el-form ref="form" :model="form" label-width="80px" :inline="true" size="small">
                <el-form-item label="">
                    <el-col :span="11">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" placeholder="开始日期" v-model="form.time1"
                                            value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col class="line" :span="1">-</el-col>
                    <el-col :span="11">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" placeholder="结束日期" v-model="form.time2"
                                            value-format="yyyy-MM-dd" style="width: 100%;"
                                            @change="changeClick"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="date"
                        label="日期">
                </el-table-column>
                <el-table-column
                        prop="charge_total"
                        label="充值总金额">
                </el-table-column>
                <el-table-column label="普通充值" align="center">
                    <el-table-column
                            prop="charge"
                            label="充值金额">
                    </el-table-column>
                    <el-table-column
                            prop="charge_person"
                            label="充值人数">
                    </el-table-column>
                    <el-table-column
                            prop="charge_pays"
                            label="已支付">
                    </el-table-column>
                    <el-table-column
                            prop="charge_unpays"
                            label="未支付">
                    </el-table-column>
                    <el-table-column
                            prop="average_pay"
                            label="人均">
                    </el-table-column>
                    <el-table-column
                            prop="complete_rate"
                            label="完成率">
                    </el-table-column>
                </el-table-column>
                <el-table-column label="VIP充值" align="center">
                    <el-table-column
                            prop="vip"
                            label="充值金额">
                    </el-table-column>
                    <el-table-column
                            prop="vip_person"
                            label="充值人数">
                    </el-table-column>
                    <el-table-column
                            prop="vip_pays"
                            label="已支付">
                    </el-table-column>
                    <el-table-column
                            prop="vip_unpays"
                            label="未支付">
                    </el-table-column>
                    <el-table-column
                            prop="vip_average_pay"
                            label="人均">
                    </el-table-column>
                    <el-table-column
                            prop="vip_complete_rate"
                            label="完成率">
                    </el-table-column>
                </el-table-column>
            </el-table>
            <div class="el-pagination">
                <el-pagination
                        background
                        @size-change="changeSize"
                        @current-change="changeCurrent"
                        :current-page="params.pagenum"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="params.pagesize"
                        :layout="this.$store.state.paginationLayout"
                        :total="params.totals">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "Statistical_Into",
        data() {
            return {
                params: {
                    pagenum: 1,
                    pagesize: 10,
                    totals: 0,
                },
                form: {
                    time1: '',
                    time2: ''
                },
                tableData: [],
                fromTitle: '',
                visible: false,
                imageUrl: '',
                activeName: 'first',
                today: '',
                yesterday: '',
                month: '',
                total: '',
            }
        },
        created() {
            this.getList()
        },
        methods: {
            changeClick(e) {
                if (e < this.form.time1) {
                    this.$message.error('结束日期不能小于开始日期');
                    this.form.time2 = '';
                }
            },
            getList() {
                let data = {
                    page: this.params.pagenum,
                    page_size: this.params.pagesize,
                    start_time: this.form.time1,
                    end_time: this.form.time2
                };
                this.$axios.post("mch/order/base_info", data).then((res) => {
                    this.params.totals = res.data.date_datas_count;
                    this.tableData = res.data.date_datas;
                    this.today = res.data.today;
                    this.yesterday = res.data.yesterday;
                    this.month = res.data.month
                    this.total = res.data.total;
                });
            },
            // 每页显示多少条
            changeSize(val) {
                this.params.pagesize = val;
                this.getList();
            },
            // 当前显示的页数
            changeCurrent(val) {
                this.params.pagenum = val;
                this.getList();
            },
            search() {
                this.params.pagenum = 1;
                this.getList();
            }

        }
    }
</script>

<style scoped>
    @media screen and (max-width: 750px) {
        .display {
            display: flex;
            flex-wrap: wrap;
        }

        .display .el-col-6 {
            width: 100%;
        }
    }

    .order-head {
        height: 200px;
        background: #f5f5f5;
        margin-top: 20px;
        border-radius: 10px;
        padding: 20px;
        box-sizing: border-box;
        font-size: 14px;
        color: #f2f2f2;
    }

    .order-head .head-top h5 {
        font-weight: 700;
    }

    .order-head .head-top p {
        /*color: #337ab7;*/
        font-size: 32px;
        padding: 10px 0;
        color: #ffffff;
    }

    .order-head .head-bottom {
        display: flex;
    }

    .order-head .head-bottom .head-bottom-item {
        flex: 1;
    }

    .order-head .head-bottom .head-bottom-item h5 {
        font-weight: 700;
        line-height: 20px;
    }

    .order-head .head-bottom .head-bottom-item p {
        line-height: 20px;
    }

    .order-head .head-bottom .head-bottom-item span {
        line-height: 20px;
        /*color: #8a6d3b;*/
        font-weight: 700;
        color: #dff0d8;
    }

</style>